// extracted by mini-css-extract-plugin
export default {"submit":"report-filter-form_submit__9Ss8D","placeHolderShimmer":"report-filter-form_placeHolderShimmer__ttbca"};